module.exports = __webpack_public_path__ + "media/brands/PremierFlooringProductsLogo-f2157d04.png";